import React, { Component } from 'react';
import NavDropdown from './NavDropdown';
import Logo from '../../../../assets/images/timesheets_logo_border.svg';
import type { User } from '../../../types';

type Props = {
  isOwner?: boolean;
  isAdmin?: boolean;
  isClient?: boolean;
  navigate: any;
  currentUser?: User | null;
  hasActiveIncidents?: boolean;
  onPayrollGeneratorClick?: Function,
  onMarketingStatsClick?: Function,
  onOpenCheckinModal?: () => void,
}

class NavBigScreen extends Component<Props, any> {
  render(): React.ReactElement {
    const { currentUser, onPayrollGeneratorClick, onMarketingStatsClick, onOpenCheckinModal, hasActiveIncidents, navigate } = this.props;
    let { isAdmin, isOwner, isClient } = this.props;

    if (currentUser) {
      isClient = currentUser.role === 'client';
      isOwner = currentUser.role === 'owner';
      isAdmin = currentUser.role === 'admin';
    }

    return (
      <div className="device-big main-nav">
        <div className="row">
          <nav className="navbar navbar-default nav-flex">
            <div className="container-fluid">
              <div className="image-wrapper" onClick={this.handleLogoClick}>
                <img src={Logo} alt="logo" className="nav-logo" />
              </div>
              <div className="invisible" />
              <div className="nav-right">
                {currentUser && currentUser.needsRemoteCheckin && (
                  <button
                    type="button"
                    className="btn btn-primary primary-color me-3"
                    onClick={onOpenCheckinModal}
                    style={{ fontSize: '14px', padding: '8px 16px' }}
                  >
                    Check In
                  </button>
                )}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {(isAdmin || isOwner) && (
                    <span style={{ cursor: 'pointer', marginRight: '12px', marginTop: '10px' }} onClick={() => navigate('/incidents')}>
                      <i className="fa fa-exclamation-triangle"
                         style={{ color: hasActiveIncidents ? '#f0ad4e' : '#ccc', fontSize: '18px' }} />
                    </span>
                  )}
                  <NavDropdown isAdmin={isAdmin} isOwner={isOwner} isClient={isClient} onPayrollGeneratorClick={onPayrollGeneratorClick} onMarketingStatsClick={onMarketingStatsClick} />
                </div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    );
  }

  handleLogoClick = () => {
    const { navigate } = this.props;
    navigate('/');
  };
}

export default NavBigScreen;
